/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar/Navbar";
import Sidebar from "../components/Sidebar/Sidebar";
import BottomNavbar from "../components/Sidebar/BottomNavbar";
import "./AdminLayout.css";

export default function AdminLayout({ children }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  // Sidebar is open by default on large screens, closed on mobile
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 768);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      // Auto-open sidebar on large screens, close on mobile
      setIsSidebarOpen(!mobile);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={`admin-layout ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}>
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} isMobile={isMobile} isAlwaysVisible={!isMobile} />

      {isMobile && isSidebarOpen && <div className="overlay" onClick={closeSidebar}></div>}

      <div className="main-section">
        <Navbar onSidebarToggle={toggleSidebar} />
        <div className="page-content">{children}</div>
      </div>

      {isMobile && <BottomNavbar setIsOpen={setIsSidebarOpen} />}
    </div>
  );
}
